import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from 'components/CustomButton';
import { ArrowForward } from '@mui/icons-material';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  dialogContainer : {
    display : 'flex',
    flexDirection : 'column',
    gap : theme.spacing(16)
  },
  upperContainer : {
    display : 'flex',
    flexDirection : 'column',
    gap : theme.spacing(3)
  },
  bottomContainer : {
    display : 'flex',
    flexDirection : 'column',
    gap : theme.spacing(6.5)
  }
}))

const CodingInterviewLaunchDialog = ({
  openDialog,
  onClose,
  onSuccess
}) => {
  const theme = useTheme();
  const classes = useStyles();

  const handleClose = () => {
    onClose(false);
  };

  return (
     <Dialog
        onClose={handleClose}
        open={openDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '870px',
            height: '516px',
            borderRadius: '8px',
            padding: theme.spacing(8, 8, 6, 8),
            position: 'relative' 
          }
        }}
      >
        <Box className={classes.dialogContainer}>
          <Box className={classes.upperContainer}>
            <Box display='flex' justifyContent='flex-end'>
              <IconButton
                onClick={handleClose}
              >
                <CloseIcon sx={{color : theme.palette.neutral['clr-900']}}/>
              </IconButton>
            </Box>
            <Typography variant='h1-regular' color='primary.clr-500'>
              Good news! We have launched CaseMaster 
            </Typography>
            <Typography variant='h6-medium' color='neutral.clr-700'>
            Practice challenging guesstimates and case studies so you can clear analyst, consultant and PM interviews.
            </Typography>
          </Box>
          <Box className={classes.bottomContainer}>
            <Box display='flex' justifyContent='center' position='relative'>
               <img
                  src='https://assets.languify.in/images/caseLaunch.png'
                  alt='toggle'
                  width={684}
                  style={{
                    zIndex : 1
                  }}
                />
                  <img
                    src='https://assets.languify.in/images/mousePointer.png'
                    alt='mouse pointer'
                    style={{
                      position : 'absolute',
                      top : 30,
                      right : 60,
                      zIndex : 2,
                    }}
                  />
            </Box>
            <CustomButton
              size='medium'
              onClick={() => {
                onSuccess(2)
                onClose(false)
              }}
              endIcon={
                <img
                  src='https://assets.languify.in/images/arrow-right-white.png'
                  alt='icon'
                  width={24}
                />
              }
              sx={{
                zIndex : 1
              }}
            >
              I'm interested
            </CustomButton>
          </Box>
        </Box>
        <img
          src='https://assets.languify.in/images/wavesLaunchDialog.png'
          alt='waves'
          width={870}
          style={{
            position : 'absolute',
            bottom : 0,
            left : 0
          }}
        />
     </Dialog>
  );
}

export default CodingInterviewLaunchDialog;
